import { number, object, string } from "yup";
// @ts-expect-error pure js
import { stringMax } from "./utils";

export const contactSchema = object({
  mail: stringMax(250).optional(),
  nom: stringMax(250).required("Le nom est obligatoire"),
  prenom: stringMax(250).optional(),
  telephone: stringMax(250).optional(),
  entreprise: stringMax(250).optional(),
  note: string().optional(),
  id_bien: number().optional(),
  id_tenant: number().optional(),
  id_property_folder: number().optional(),
  id_profile_bailleur: number().optional(),
  domaine: stringMax(250).required(" "),
});

export const contactIV = {
  mail: "",
  nom: "",
  prenom: "",
  telephone: "",
  entreprise: "",
  note: "",
  id_bien: "",
  id_tenant: "",
  id_profile_bailleur: "",
  id_property_folder: "",
  domaine: "",
};

export interface Contact {
  id: number;
  nom: string;
  prenom?: string;
  telephone?: string;
  mail?: string;
  entreprise?: string;
  note?: string;
  domaine?: string;
  id_bien?: number;
  id_tenant?: number;
  id_property_folder?: number;
  id_profile_bailleur?: number;
}
